import { ThemeConfig } from '@chakra-ui/react';

const config: ThemeConfig = { initialColorMode: 'light' };

export default config;
